import React from 'react';

export default function ErrorComponent () {    

    return (
        <div className="wrap" style={{padding: "0px 0px 30px 0px"}}>
            <div className="text-center">
                <img src="https://cdncontribute.geeksforgeeks.org/wp-content/uploads/404.png" style={{
                    maxWidth:"100%",
                    maxHeight:"100%"
                }}/>
                <p align="center"><a href="/">Go to Homepage</a></p>
            </div>
        </div>
    );
}